import { ChevronRight } from "@mui/icons-material";
import {
  Box,
  Chip,
  CircularProgress,
  Link,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { API_VERSION, API_RESULT } from "../../enums/common.enum";
import useAxiosInstance from "../../hooks/useAxiosInstance";
import { handleError, a11yProps } from "../../utils/common";
import Dues from "../Borrowers/SingleBorrower/Dues";
import Invoices from "../Borrowers/SingleBorrower/Invoice";
import Summary from "../Borrowers/SingleBorrower/Summary";
import TabPanel from "../../components/UI/tabPanel";

const SingleBorrower = () => {
  const [loading, setLoading] = useState(false);
  const privateInstance = useAxiosInstance();
  const [borrowerInfo, setBorrowerInfo] = useState<any>(null);
  const [kycData, setKycData] = useState<any[]>([]);
  const params = useParams();
  const activeBorrowerId = params?.borrowerId;
  const location = useLocation();
  const activeTab: any = new URLSearchParams(location.search).get("tab") || 1;
  const [value, setValue] = useState(Number(activeTab - 1));
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const navigate = useNavigate();
  const [visitedTabs, setVisitedTabs] = useState<number[]>([]);

  const getBorrowerInfo = async () => {
    setLoading(true);
    try {
      const result = await privateInstance.get(
        `${API_VERSION.V3}/borrowers?borrower_id=${activeBorrowerId}`,
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        setBorrowerInfo(result.data.response);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBorrowerInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateVisitedTabs = (tab: number, updateType: string) => {
    if (updateType === "add") {
      setVisitedTabs([...(new Set([...visitedTabs, tab]) as any)]);
    } else {
      setVisitedTabs(visitedTabs.filter((t) => t !== tab));
    }
  };

  return (
    <div>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          {borrowerInfo ? (
            <Box m={-3}>
              <Box
                p={2}
                sx={{ backgroundColor: "#E6EEFF" }}
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                flexWrap="wrap"
                justifyContent="space-between"
                alignItems="center"
                gap={2}
              >
                <Stack>
                  <Box display="flex" alignItems="center" gap={1} pb={2}>
                    <Link
                      color="secondary"
                      href="/suppliers"
                      sx={{
                        textDecoration: "none",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      All Borrowers
                    </Link>
                    <ChevronRight color="secondary" />
                    <Typography
                      variant="body2"
                      sx={{ textTransform: "capitalize" }}
                    >
                      {borrowerInfo?.name}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    flexWrap="wrap"
                    alignItems="baseline"
                    gap={0.75}
                    pb={2}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "20px !important",
                        textTransform: "capitalize",
                      }}
                    >
                      {borrowerInfo?.name}
                    </Typography>
                    {borrowerInfo?.status && (
                      <Stack direction="row" gap={1}>
                        <Chip
                          size="small"
                          label={borrowerInfo?.status}
                          sx={{
                            textTransform: "capitalize",
                            backgroundColor:
                              borrowerInfo?.status === "active"
                                ? "#C6F6D5"
                                : borrowerInfo?.status === "inactive"
                                  ? "#FEEBC8"
                                  : "#C53030",
                            padding: "6px",
                            color:
                              borrowerInfo?.status === "active"
                                ? "#000"
                                : borrowerInfo?.status === "inactive"
                                  ? "#000"
                                  : "#fff",
                          }}
                        />
                      </Stack>
                    )}
                  </Box>
                </Stack>
              </Box>
              <>
                {/* TODO:refactor tabs into a function */}
                <Tabs
                  variant="scrollable"
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    sx={{ fontSize: "12px" }}
                    label="Profile"
                    {...a11yProps(0)}
                    onClick={() => navigate(`/borrower/${activeBorrowerId}`)}
                  />
                  <Tab
                    sx={{ fontSize: "12px" }}
                    label="Invoice"
                    {...a11yProps(1)}
                    onClick={() =>
                      navigate(`/borrower/${activeBorrowerId}?tab=2`)
                    }
                  />
                  <Tab
                    sx={{ fontSize: "12px" }}
                    label="Dues"
                    {...a11yProps(1)}
                    onClick={() =>
                      navigate(`/borrower/${activeBorrowerId}?tab=3`)
                    }
                  />
                </Tabs>
                <Box px={2}>
                  <TabPanel value={value} index={0}>
                    <Summary
                      borrowerInfo={borrowerInfo}
                      setBorrowerInfo={setBorrowerInfo}
                      kycData={kycData}
                      setKycData={setKycData}
                      visitedTabs={visitedTabs}
                      updateVisitedTabs={updateVisitedTabs}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <Invoices
                      borrowerInfo={borrowerInfo}
                      setBorrowerInfo={setBorrowerInfo}
                      visitedTabs={visitedTabs}
                      updateVisitedTabs={updateVisitedTabs}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <Dues
                      borrowerInfo={borrowerInfo}
                      setBorrowerInfo={setBorrowerInfo}
                      visitedTabs={visitedTabs}
                      updateVisitedTabs={updateVisitedTabs}
                    />
                  </TabPanel>
                </Box>
              </>
            </Box>
          ) : null}
        </>
      )}
    </div>
  );
};

export default SingleBorrower;
